<script lang="typescript">
    import { createEventDispatcher } from "svelte"
    import { getUsers } from "../api"
    import Overlay from "./Overlay.svelte"

    const dispatch = createEventDispatcher()

    export let user: User
</script>

<Overlay>
    <img
        slot="trigger"
        src="{user?.avatar_url}"
        alt="?"
        style="width:30px; border-radius: 30px; cursor: pointer;"
    />
    <div class="content" slot="content" style="text-align: left; cursor: pointer;">
        {#await getUsers() then newUsers}
            {#each newUsers as newUser}
                <div
                    on:click="{() => {
                        dispatch('selected', newUser)
                    }}"
                >
                    <img
                        src="{newUser.avatar_url}"
                        alt=""
                        style="width:20px; border-radius: 20px;"
                    />
                    {newUser.firstname}
                </div>
            {/each}
        {/await}
    </div>
</Overlay>
